import React from 'react'
import './logo.scss'

const Logo = () => (
  <span className="logo">servd<span className="primary">.</span></span>
)

export default Logo
